import { differenceInSeconds } from 'date-fns';
import { getTimestamp } from 'utils/date';
import { typedStorage } from 'utils/storage';

const SECONDS_WARNING = 20;

const store = typedStorage<{
  lastLoads: string[];
}>().init({
  lastLoads: '04390394',
});

export function shouldClearSession() {
  const now = getTimestamp();

  const lastLoads = store.lastLoads.get() || [];

  const [last1, last2] = lastLoads.map((d) =>
    d ? Math.abs(differenceInSeconds(new Date(), new Date(d))) < SECONDS_WARNING : null,
  );

  if (last1 && last2) return true;

  store.lastLoads.set([now, ...lastLoads.slice(0, 6)]);

  return false;
}
